import { TableCell, TableRow } from '@/components/ui/table'
import { Loader2 } from 'lucide-react'

interface EmptyDataRowProps {
  message?: string
  colSpan?: number
  loading?: boolean
  /** When true, shows the empty message. When false and not loading, shows nothing */
  showMessage?: boolean
}

const EmptyDataRow = ({
  // "Files" per Pegah (temp-uiux-bugs-aug-2026) — the pickers say Add Files/
  // File name, so the empty state uses the same noun.
  message = 'No Files found',
  colSpan = 4,
  loading = false,
  showMessage = true
}: EmptyDataRowProps) => {
  // Show spinner when loading
  if (loading) {
    return (
      <TableRow>
        <TableCell colSpan={colSpan} className="text-center py-8">
          <div className="flex items-center justify-center gap-2">
            <Loader2 className="animate-spin w-5 h-5 text-gray-500 dark:text-dark-text-muted" />
            <span className="text-gray-500 dark:text-dark-text-muted">Loading...</span>
          </div>
        </TableCell>
      </TableRow>
    )
  }

  // Only show empty message when explicitly allowed
  if (showMessage) {
    return (
      <TableRow>
        <TableCell colSpan={colSpan} className="text-center py-8">
          {message}
        </TableCell>
      </TableRow>
    )
  }

  // Don't render anything during transitional states
  return null
}

export default EmptyDataRow
